import { actionType } from "./../constants/requirement";
import { arrayToObjectById } from "./../../../components/util";

const initialState = {
    domain: {
        form: {
            tipo_requisito: { name: "tipo_requisito", value: null },
            designacao: { name: "designacao", value: null },
        },
        byId: {},
        metaData: {
            attributes: {},
        },
    },
    app: {
        isFetched: false,
        isFetching: false, //TODO: for check if app is calling to server
    },
};

export const requirementReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.insert:
            return {
                ...state,
                domain: {
                    ...state.domain,
                    form: {
                        tipo_requisito: { name: "tipo_requisito", value: null },
                        designacao: { name: "designacao", value: null },
                    },
                },
            };

        case actionType.setField:
            return {
                ...state,
                domain: {
                    ...state.domain,
                    form: {
                        ...state.domain.form,
                        ...action.payload,
                    },
                },
            };
        case actionType.select:
            return {
                ...state,
                domain: {
                    ...state.domain,
                    byId: arrayToObjectById({
                        array: Array.isArray(action.payload["linha"])
                            ? action.payload["linha"]
                            : [action.payload["linha"]],
                        id: "id_requisito",
                    }),
                    metaData: {
                        ...state.domain.metaData,
                        attributes: {
                            ...action.payload["@attributes"],
                        },
                    },
                },
                app: {
                    isFetched: true,
                },
            };

        case actionType.update:
            return {
                ...state,
                domain: {
                    ...state.domain,
                    form: {
                        tipo_requisito: { name: "tipo_requisito", value: null },
                        designacao: { name: "designacao", value: null },
                    },
                },
            };
        default:
            return state;
    }
};
